import type { SubscriptionPlan, SubscriptionPlanBase } from "../../../types/admin";
import { createAdminBaseService } from "./adminBaseService";

const base = createAdminBaseService<SubscriptionPlan, SubscriptionPlanBase>({
  tableName: "subscription_plans",
  searchColumns: ["name", "display_name"],
});

export class AdminPlanService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
